import { z } from "zod";

export const airdropSchema = z.object({
  walletAddress: z.string().min(32).max(44),
});
